import styled from "styled-components";

export const ModalWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  padding: 0 20px;
  background-color: rgba(8, 8, 17, 0.8);
  cursor: pointer;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 90%;
  height: 50%;
  margin-top: 42px;
`;

export const Imagem = styled.img`
  align-self: center;
  max-width: 100%;
  height: auto;
  object-fit: contain;
`;